<form class="form-inline">
  <div class="form-group mx-sm-3 mb-2">
    <label style="margin-right: 20px" >Vitesse Max</label>
    <input type="number" class="form-control" placeholder="V.Max" name="speed" [(ngModel)]="speedAlertConfiguration.value1" style="width: 70px;border-radius: 10px">
  </div>
<div style="margin-top: 20px">

  <app-email-manager [enableGlobalConfigToAllVehicules]="enableGlobalConfigToAllVehicules" [emailMode]="alert.emailMode" [enableGlobalConfig]="enableGlobalConfig" [emailsHash]="alert.emails" (onChange)="emailSettings($event)"></app-email-manager>

</div>




  <div class="form-group" style="margin-left: 470px;margin-top: -44px">
      <label>Activer l'alert</label>
      <div class="input-group" style="margin-left: 5px">
          <mat-slide-toggle [(ngModel)]="alert.isActive" name="isActive" ></mat-slide-toggle>
      </div>
  </div>



  <div>
    <div style="margin: 10px 0 10px 0" *ngIf="!showAdvancedSettings"  class="advanced-link" (click)="collapseAdvancedSettings()">
      <i class="fa fa-plus-square"></i>
      <span class="link">paramétrage avancé</span>
    </div>

    <div style="margin: 10px 0 10px 0" *ngIf="showAdvancedSettings" class="advanced-link"  (click)="collapseAdvancedSettings()">
      <i class="fa fa-minus-square"></i>
      <span class="link">masquer paramétrage avancé</span>
    </div>

    <app-cron-settings *ngIf="showAdvancedSettings" [cron]="cronAlertConfiguration"></app-cron-settings>

  </div>
  <button type="submit" class="btn btn-flat btn-primary pull-right" style="margin-top: 45px;" (click)="save()">
      Sauvegarder
  </button>

</form>

<ngx-loading [show]="loader" [config]="{ backdropBorderRadius: '0px',fullScreenBackdrop:true }"></ngx-loading>
